import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M13.79,8l0,0a.75.75,0,0,1-1.06,0L8.75,3.86V14a.75.75,0,0,1-1.5,0V3.86L3.31,7.94a.75.75,0,0,1-1.08-1L7.46,1.47a.59.59,0,0,1,.18-.13l.05,0a.47.47,0,0,1,.15-.06h.3a.72.72,0,0,1,.38.21L13.77,6.9A.75.75,0,0,1,13.79,8ZM8.15,1.26a.72.72,0,0,1,.38.21A.68.68,0,0,0,8.15,1.26Z';
const draw24px = 'M17.75,10a.77.77,0,0,1-.52.21.74.74,0,0,1-.54-.23L12.75,5.86V20a.75.75,0,0,1-1.5,0V5.86L7.31,10a.75.75,0,1,1-1.08-1l5.23-5.43h0a.78.78,0,0,1,.38-.2,1.5,1.5,0,0,1,.3,0,.78.78,0,0,1,.38.2h0l5.23,5.43A.75.75,0,0,1,17.75,10Zm-5.9-6.7a.74.74,0,0,0-.38.2A.78.78,0,0,1,11.85,3.27Zm0,0a1.5,1.5,0,0,1,.3,0l-.15,0Zm.3,0a.78.78,0,0,1,.38.2A.74.74,0,0,0,12.15,3.27Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const ArrowUpIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'arrowUp'));
ArrowUpIcon.displayName = 'ArrowUpIcon';
ArrowUpIcon.propTypes = Icon.propTypes;
ArrowUpIcon.renderIcon = props => /*#__PURE__*/React.createElement(ArrowUpIcon, props);
export default ArrowUpIcon;
//# sourceMappingURL=ArrowUpIcon.js.map